module.exports = __webpack_public_path__ + "img/PenguinBar.28a327e8.png";